import { CompanyType } from '@/types/CompanyType'
import { List, MoreVertical, Pencil, Trash2 } from 'lucide-react'
import { Dropdown } from 'react-bootstrap'
import { Link } from 'react-router-dom'

type CompanyMenuType = {
    company: CompanyType
    handleDelete: (company: CompanyType) => void
}

export default function CompanyMenu ({companyMenuProps}: {companyMenuProps: CompanyMenuType}) {
    const {company, handleDelete} = companyMenuProps
    return (
      <Dropdown>
        <Dropdown.Toggle variant='secondary' id='dropdown-basic' as='div' className='no-arrow'>
          <MoreVertical size={20} />
        </Dropdown.Toggle>
        <Dropdown.Menu>
          <Dropdown.Item>
            <Link to={'/societes/detail/' + company?.id} className='py-2 d-block'>
              <List size={16} /> Détail
            </Link>
          </Dropdown.Item>
          <Dropdown.Item
            href={'/societes/modification/' + company?.id}
            className='py-2 d-block'
          >
            <Pencil size={16} /> Modifier
          </Dropdown.Item>
          <Dropdown.Item onClick={() => handleDelete(company)} className='py-2'>
            <Trash2 size={16} /> Supprimer
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
    )
}